// import { ACCOUNT_NUMBER_MIN_LENGTH } from 'Store/userBankDetails/constants';
//import { IErrorText } from 'Pages/_error';

export const GENERIC_ERROR = 'Something went wrong';
export const INVALID_DATE = 'Invalid date';

export const CLAIM_REGISTERED_CODE = 422;
export const UNAUTHORIZED_CODE = 401;
export const FORBIDDEN_CODE = 403;
export const PAGE_NOT_FOUND = 404;
export const FALLBACK_410 = 410;

export const ECONNABORTED = 'ECONNABORTED';
export const POLICY_NOT_FOUND = 'POLICY_NOT_FOUND';
export const THIRD_PARTY_POLICY = 'THIRD_PARTY_POLICY';
export const CANCELLED_POLICY = 'CANCELLED_POLICY';

export const errorTexts: { [key: string]: any } = {
    [CLAIM_REGISTERED_CODE]: {
        heading: 'Your claim request has already been submitted',
        subText: 'Redirecting you to your account',
        redirectURL: `/myaccount`,
        ctaText: 'Back to home',
    },

    [UNAUTHORIZED_CODE]: {
        heading: 'Redirecting you to login',
        subText: 'Sorry, but you are not authorized to access this page.',
    },

    [FORBIDDEN_CODE]: {
        heading: 'Redirecting you to your account screen',
        subText: '',
    },

    [PAGE_NOT_FOUND]: {
        heading: 'Looks like the page does not exist',
        subText: '',
        redirectURL: `/myaccount`,
        ctaText: 'Back to home',
    },

    [POLICY_NOT_FOUND]: {
        heading: 'This policy does not exist',
        subText: 'Please enter a valid policy number',
        redirectURL: `/myaccount`,
        ctaText: 'Back to home',
    },

    [THIRD_PARTY_POLICY]: {
        heading: `Please write to <a href="mailto:hello@acko.com">hello@acko.com</a> or call us @ <a href="tel:1800-266-2256">1800-266-2256</a> to register your claim`,
        subText: '',
        redirectURL: `/myaccount`,
        ctaText: 'Back to home',
    },

    [CANCELLED_POLICY]: {
        heading: 'This policy has been cancelled',
        subText: 'Please enter an active policy number',
        redirectURL: `/myaccount`,
        ctaText: 'Back to home',
    },

    default: {
        heading: 'Oops! Something went wrong',
        subText: `We're sorry. This usually never happens.`,
        redirectURL: '/myaccount',
        ctaText: 'Back to home',
    },
};

export const FIELD_REQUIRED = 'This field is required';
export const DATA_UNAVAILABLE = 'Not available';
export const INVALID_PHONE_NUMBER = 'Please enter a valid phone number';
export const INVALID_EMAIL = 'Please enter a valid email';
export const DIFFERENT_ACCOUNT_NUMBERS = "Account numbers don't match";
export const ACCEPT_CONFIRMATION = 'Please accept the confirmation to proceed.';
export const CANCELLED_CHEQUE_REQUIRED = 'Cancelled cheque is required.';
export const MESSAGE_REQUIRED = 'Please enter a message';
export const GARAGE_NAME_MAX_LENGTH = 'Garage name cannot be too long';
